// @ts-nocheck
let potUiObserver = null;
let potToggleInFlight = false;
let desiredPotCheckedState = null;

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('cart-form');
  if (!form) return;

  const enablePot = form.dataset.enablepot === 'true';
  if (!enablePot) return;

  refreshPotUi();

  attachPotUiObserver();
});

function refreshPotUi() {
  updateCheckboxVisibility();
  syncCartItems();
}

function schedulePotUiRefresh() {
  // Cart DOM morphs after quantity changes, so retry after re-render settles.
  [60, 260, 650].forEach((delay) => {
    setTimeout(refreshPotUi, delay);
  });
}

function attachPotUiObserver() {
  if (potUiObserver) return;

  const cartRoot = document.querySelector('cart-items-component') || document.body;
  if (!cartRoot) return;

  let rafId = 0;
  potUiObserver = new MutationObserver(() => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      const config = getPotConfig();
      if (!config || config.form.dataset.enablepot !== 'true') return;
      refreshPotUi();
    });
  });

  potUiObserver.observe(cartRoot, {
    childList: true,
    subtree: true,
  });
}

function getPotConfig() {
  const form = document.getElementById('cart-form');
  if (!form) return null;

  return {
    form,
    potType: form.dataset.pottype?.toLowerCase(),
    potProduct: form.dataset.potid,
    sectionId: form.closest('cart-items-component')?.dataset.sectionId || null,
  };
}

function getPotVariantId(productId) {
  return productId?.split('/').pop();
}

function updateCheckboxVisibility() {
  const config = getPotConfig();
  if (!config) return;

  const { potType, potProduct } = config;
  if (!potType || !potProduct) return;

  const cartItems = Array.from(document.querySelectorAll('.cart-items__table-row[data-key]'));
  const hasTargetProduct = cartItems.some((item) => item.dataset.producttype?.toLowerCase() === potType);
  const potVariantId = getPotVariantId(potProduct);
  let checkboxContainer = document.getElementById('checkbox-container');

  if (hasTargetProduct) {
    if (!checkboxContainer) {
      checkboxContainer = document.createElement('div');
      checkboxContainer.id = 'checkbox-container';
      checkboxContainer.innerHTML = `
        <div class="pot-box">
          <input type="checkbox" id="potProduct" name="potProduct" aria-label="potproduct" value="potProduct">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
          <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <label for="potProduct">${window.potTextFromLiquid || 'Add a recommended pot!'}</label>
        </div>`;

      const subtotalAnchor = document.querySelector('.cart-totals__original-container');
      if (subtotalAnchor) {
        subtotalAnchor.insertAdjacentElement('afterend', checkboxContainer);
      }
    }

    const potCheckbox = document.getElementById('potProduct');
    if (potCheckbox) {
      const hasPotInCart = cartItems.some((item) => item.dataset.key?.startsWith(`${potVariantId}:`));
      potCheckbox.checked = desiredPotCheckedState !== null ? desiredPotCheckedState : hasPotInCart;
      potCheckbox.disabled = potToggleInFlight;
      potCheckbox.onchange = () => {
        if (potToggleInFlight) return;
        desiredPotCheckedState = potCheckbox.checked;
        potCheckbox.disabled = true;
        potCheckbox.checked ? addToCart(potProduct, potType) : removeFromCart(potProduct);
      };
      checkboxContainer.style.display = 'none';
    }
  } else if (checkboxContainer) {
    checkboxContainer.style.display = 'none';
  }

  if (!hasTargetProduct && cartItems.some((item) => item.dataset.key?.startsWith(`${potVariantId}:`))) {
    setTimeout(() => removeFromCart(potProduct), 0);
  }
}

function syncCartItems() {
  const config = getPotConfig();
  if (!config) return;

  const { potType, potProduct } = config;
  if (!potType || !potProduct) return;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const roseQuantity = cart.items.reduce((qty, item) => (
        item.product_type?.toLowerCase() === potType ? qty + item.quantity : qty
      ), 0);
      const potVariantId = getPotVariantId(potProduct);
      const potItem = cart.items.find((item) => item.key.startsWith(`${potVariantId}:`));
      const potCheckbox = document.getElementById('potProduct');

      if (desiredPotCheckedState === false && !potItem) desiredPotCheckedState = null;
      if (desiredPotCheckedState === true && potItem && potItem.quantity === roseQuantity) desiredPotCheckedState = null;

      if (!potCheckbox) return;
      if (potToggleInFlight) return;

      if (potCheckbox.checked && potItem && potItem.quantity !== roseQuantity) {
        addToCart(potProduct, potType);
      } else if (!potCheckbox.checked && potItem) {
        removeFromCart(potProduct);
      } else if (potCheckbox.checked && !potItem && roseQuantity > 0) {
        addToCart(potProduct, potType);
      }
    })
    .catch(console.error);
}

function dispatchCartUpdate(cartResource, sections = null) {
  const itemCount = resolveCartItemCount(cartResource, sections);
  if (itemCount === null) return;

  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: cartResource,
      sourceId: 'custom-pot',
      data: {
        itemCount,
        source: 'custom-pot',
        sections: sections || cartResource?.sections || {},
      },
    },
  }));
}

function resolveCartItemCount(cartResource, sections = null) {
  if (typeof cartResource?.item_count === 'number') return cartResource.item_count;

  const sectionMap = sections || cartResource?.sections;
  if (!sectionMap || typeof sectionMap !== 'object') return null;

  const htmlSnippets = Object.values(sectionMap).filter((snippet) => typeof snippet === 'string');
  for (const snippet of htmlSnippets) {
    const doc = new DOMParser().parseFromString(snippet, 'text/html');

    const hiddenCount = doc.querySelector('[ref="cartItemCount"]')?.textContent?.trim();
    if (hiddenCount && !Number.isNaN(Number(hiddenCount))) return Number(hiddenCount);

    const bubbleCount = doc.querySelector('.cart-bubble__text-count')?.textContent?.trim();
    if (bubbleCount && !Number.isNaN(Number(bubbleCount))) return Number(bubbleCount);
  }

  return null;
}

function addToCart(productId, potType) {
  potToggleInFlight = true;
  const loader = document.getElementById('pot-loader');
  if (loader) loader.style.display = 'flex';

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      let roseQuantity = 0;
      let potItemKey = null;
      const potVariantId = getPotVariantId(productId);

      cart.items.forEach((item) => {
        if (item.product_type?.toLowerCase() === potType) roseQuantity += item.quantity;
        else if (item.key.startsWith(`${potVariantId}:`)) potItemKey = item.key;
      });

      const updateCart = (url, body) => fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      }).then((responseData) => {
        updateCartCount(responseData.item_count);
        if (roseQuantity === 0 && document.getElementById('potProduct')) {
          document.getElementById('potProduct').checked = false;
        }
        dispatchCartUpdate(responseData);
      });

      const addCart = () => {
        const config = getPotConfig();
        const sections = ['cart-ajax'];
        if (config?.sectionId) sections.push(config.sectionId);

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: productId, quantity: roseQuantity }], sections }),
        }).then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        }).then((responseData) => {
          updateAjaxCartCount(responseData.sections, sections);
          const countFromSections = resolveCartItemCount(responseData, responseData.sections);
          if (countFromSections !== null) {
            dispatchCartUpdate(
              { ...responseData, item_count: countFromSections },
              responseData.sections
            );
            return;
          }

          return fetch('/cart.js')
            .then((cartResponse) => cartResponse.json())
            .then((cart) => {
              dispatchCartUpdate(
                { ...responseData, item_count: cart.item_count },
                responseData.sections
              );
            });
        });
      };

      (potItemKey ? updateCart('/cart/change.js', { id: potItemKey, quantity: roseQuantity }) : addCart())
        .catch((error) => console.error('Cart operation error:', error))
        .finally(() => {
          potToggleInFlight = false;
          schedulePotUiRefresh();
          if (loader) loader.style.display = 'none';
        });
    })
    .catch((error) => {
      console.error('Error fetching cart data:', error);
      potToggleInFlight = false;
      schedulePotUiRefresh();
      if (loader) loader.style.display = 'none';
    });
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-bubble__text-count').forEach((cartCount) => {
    cartCount.textContent = count < 100 ? String(count) : '';
    cartCount.classList.toggle('hidden', count === 0);
  });
  document.querySelectorAll('.cart-bubble').forEach((bubble) => {
    bubble.classList.toggle('visually-hidden', count === 0);
  });
}

function updateAjaxCartCount(sectionsMap, sectionIds) {
  if (!sectionsMap || !Array.isArray(sectionIds)) return;

  const firstHtml = sectionIds.map((id) => sectionsMap[id]).find(Boolean);
  if (!firstHtml) return;

  const html = new DOMParser().parseFromString(firstHtml, 'text/html');
  const newCartCount = html.querySelector('.cart-bubble__text-count');
  const cartCounts = document.querySelectorAll('.cart-bubble__text-count');
  const newBubble = html.querySelector('.cart-bubble');
  const bubbles = document.querySelectorAll('.cart-bubble');

  if (newCartCount && cartCounts.length > 0) {
    cartCounts.forEach((count) => {
      count.textContent = newCartCount.textContent;
      count.classList.toggle('hidden', newCartCount.classList.contains('hidden'));
    });
  }

  if (newBubble && bubbles.length > 0) {
    bubbles.forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', newBubble.classList.contains('visually-hidden'));
    });
  }
}

function removeFromCart(productId) {
  potToggleInFlight = true;
  desiredPotCheckedState = false;
  const loader = document.getElementById('pot-loader');
  if (loader) loader.style.display = 'flex';

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const potVariantId = getPotVariantId(productId);
      const item = cart.items.find((lineItem) => lineItem.key.startsWith(`${potVariantId}:`));

      if (item) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        }).then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        }).then((responseData) => {
          updateCartCount(responseData.item_count);
          dispatchCartUpdate(responseData);
        }).catch((error) => console.error('Error removing product from cart:', error))
          .finally(() => {
            potToggleInFlight = false;
            schedulePotUiRefresh();
            if (loader) loader.style.display = 'none';
          });
      } else if (loader) {
        potToggleInFlight = false;
        schedulePotUiRefresh();
        loader.style.display = 'none';
      }
    })
    .catch((error) => {
      console.error('Error fetching cart data:', error);
      potToggleInFlight = false;
      schedulePotUiRefresh();
      if (loader) loader.style.display = 'none';
    });
}

document.addEventListener('cart:update', () => {
  const config = getPotConfig();
  if (!config || config.form.dataset.enablepot !== 'true') return;

  schedulePotUiRefresh();
});

document.addEventListener('cart:updated', () => {
  const config = getPotConfig();
  if (!config || config.form.dataset.enablepot !== 'true') return;

  schedulePotUiRefresh();
});
